import Image from '@tiptap/extension-image';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import ResizableImageTemplate from '../../assets/custom-tiptap-nodes/templates/ResizableImageTemplate.vue';

const CustomImage = Image.extend({
	name: 'CustomImage',
	addAttributes() {
		// Return an object with attribute configuration
		return {
			...this.parent?.(),
			src: {
				default: '',
				renderHTML: attributes => {
					// … and return an object with HTML attributes.
					return {
						src: attributes.src,
					};
				},
			},
      loading: {
        default: 'lazy',
        // renderHTML: attributes => {
        //   return {
        //     loading: attributes.loading
        //   }
        // }
      },
			width: {
				default: 750,
				renderHTML: ({ width }) => ({ width }),
			},
			height: {
				default: 'auto',
                renderHTML: (attributes) => {
                    // console.log(attributes, 'attributes.height');
                    return {
                        height: attributes.height
                    };
                }
			},
			isDraggable: {
				default: true,
				// We don't want it to render on the img tag
				renderHTML: attributes => {
					return {};
				},
			},
		};
	},
	addNodeView() {
		return VueNodeViewRenderer(ResizableImageTemplate);
	},
});

export { CustomImage };
export default CustomImage;